export class RoutingKeys {
    // HOME
    public static readonly HOME = '';
    public static readonly PAYMENT_INTENT = 'payment-intent';
    public static readonly CONNECT = 'connect';
    public static readonly ITEM = 'item';
    public static readonly SHOP = 'shop';
    public static readonly USER = 'user';
    public static readonly NOT_FOUND = 'not-found';
}
